import React from 'react'
import QRCodeGenerator from './QRCodeGenerator';

const PrintLabel = ({ qrCodeSrc, productName, mrp, logoSrc, dateOfMfg }) => {
    const formatProductNames = (name) => {
        const dimensionsMatch = name.match(/\d+x\d+x\d+\/\d+ x \d+ x \d+MM/) || name.match(/\d+x\d+\/\d+ x \d+MM/);
        if (dimensionsMatch) {
        // Insert a line break before the dimensions
        return name.replace(dimensionsMatch[0], `<br/>${dimensionsMatch[0]}`);
        }
        return name;
    }
    return (
        <div className='container-fluid'>
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", padding: "0 2mm"}}>
                <div style={{display: "flex", flexDirection: "column"}}>
                    <span style={{flex: "1", margin: "auto"}}><QRCodeGenerator value={qrCodeSrc} size={75} /></span>
                    <span style={{flex: "1", margin: "auto"}}><img className="logo" style={{ maxWidth: '100%', height: "20mm" }} src={logoSrc} alt="Logo" /></span>
                </div>
                <div style={{flex: "1", display: "flex", flexDirection: "column", paddingLeft: "2mm"}}>
                    <span style={{fontSize: "0.8em", fontWeight: "600", flex: "1", lineHeight: "1.3em", letterSpacing: "0.2em"}} dangerouslySetInnerHTML={{__html: formatProductNames(productName)}}></span>
                    <span style={{fontSize: "0.9em", marginTop: '1em', marginBottom: "1em", fontWeight: "600", flex: "1",}}>MRP: ₹ {mrp}</span>
                    <span style={{fontSize: "0.6em", marginBottom: "1em"}}>DATE OF MFG: {dateOfMfg}</span>
                    <span style={{fontSize: "0.65em", lineHeight: "1.1em", letterSpacing: "0.2em", flex: "1"}}>Manufactured By:<br /><b>Apogee Mattress Pvt Ltd</b><br />Plot No 21, CNI Complex, Patia<br />Bhubaneswar-24, Odisha</span>
                </div>
            </div>
        </div>
    )};

export default PrintLabel
